import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ApplicationProxyService } from '../shared/services/applicationproxy.service';
import { FlowManagerService } from '../shared/services/flowmanager.service';

@Injectable()
export class DepositAccountsResolver implements Resolve {
  constructor(appProxy: ApplicationProxyService, flowManager: FlowManagerService) {
    this.appProxy = appProxy;
    this.flowManager = flowManager;
  }

  resolve(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    return new Promise(resolve => {
      this.appProxy.getDepositAccounts(v => resolve(v));
    });
  }
}
